import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationModalComponent } from "src/app/components/common/confirmation-modal/confirmation-modal.component";
import { AuthService } from "src/app/services/auth.service";
import { saveUserDataInSession } from "src/app/utils/session-data";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  state = "login";

  loginForm: FormGroup;
  registerForm: FormGroup;

  isButtonOn = true;

  data: any = {};
  registerData: any = {};

  otp: string | null = null;
  response: any;

  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      width: "30px",
      height: "30px",
    },
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private dialog: MatDialog
  ) {
    this.loginForm = this.formBuilder.group({
      your_name: ["", Validators.required],
      agreeTerm: [false],
    });

    this.registerForm = this.formBuilder.group({
      name: ["", Validators.required],
      last_name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
    });
  }

  returnUrl: string = "/international-class"; // default fallback

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params["returnUrl"]) {
        const url = decodeURIComponent(params["returnUrl"]);
        this.returnUrl = url;
      }
    });
  }

  onOtpChange(otp: string) {
    this.otp = otp;
  }

  onSubmit() {
    if (!this.isButtonOn || !this.loginForm.valid) return;

    this.isButtonOn = false;
    const formValue = this.loginForm.value;

    const body = {
      mobile: formValue.your_name.toLowerCase(),
      access_type: "web",
      otp_in: formValue.agreeTerm,
    };

    this.auth.otpRequest(body).subscribe(
      (res: any) => {
        this.isButtonOn = true;
        if (!res.error) {
          this.openOtp(formValue.your_name.toLowerCase(), res.details.otp_ref);
        } else {
          this.openDialog(res.error_message);
        }
      },
      (error) => {
        this.isButtonOn = true;
        this.openDialog(error.error.message);
      }
    );
  }

  openOtp(number: string, otpRef: string) {
    this.state = "otp";
    this.scrollToTop();
    this.data.number = number;
    this.data.otpRef = otpRef;
  }

  changeNumber() {
    this.state = "login";
    this.scrollToTop();
  }

  onOtpSubmit() {
    if (this.otp?.length !== 4 || !this.isButtonOn) return;
    this.isButtonOn = false;

    const body = {
      mobile: this.data.number,
      access_type: "web",
      otp: this.otp,
      otp_ref: this.data.otpRef,
    };

    this.auth.otpVerify(body).subscribe(
      (res: any) => {
        if (!res.error) {
          if (res.details.first_name && res.details.last_name) {
            saveUserDataInSession(res.details);
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.response = res.details;
            this.openRegister(
              res.details.credentials.access_token,
              res.details.email,
              res.details.first_name,
              res.details.last_name
            );
          }
        } else {
          this.openDialog(res.error_message);
        }
      },
      (error) => {
        this.isButtonOn = true;
        this.openDialog(error.error.message);
      }
    );
  }

  openRegister(
    token: string,
    email: string,
    first_name: string,
    last_name: string
  ) {
    this.state = "register";
    this.scrollToTop();
    this.registerData = {
      token,
      email,
      first_name,
      last_name,
    };

    // Update registerForm values
    this.registerForm.patchValue({
      name: first_name,
      last_name: last_name,
      email: email,
    });
  }

  onRegisterSubmit() {
    if (!this.registerForm.valid) return;
    this.isButtonOn = false;

    const formData = this.registerForm.value;
    const body = {
      first_name: formData.name,
      last_name: formData.last_name,
      email: formData.email,
    };

    this.auth.registerMethod(body, this.registerData.token).subscribe(
      (res: any) => {
        this.isButtonOn = true;
        if (!res.error) {
          saveUserDataInSession(res.details);
          this.router.navigateByUrl(this.returnUrl);
        } else {
          this.openDialog(res.message);
        }
      },
      (error) => {
        this.isButtonOn = true;
        this.openDialog(error.error.message);
      }
    );
  }

  openDialog(err: string) {
    if (err === "Validation Error") {
      err = "Please Enter a Strong Password";
    }

    if (
      err.includes(
        'duplicate key value violates unique constraint "auth_user_username_key"'
      )
    ) {
      err = "User already exists";
    }

    this.dialog.open(ConfirmationModalComponent, {
      enterAnimationDuration: "350ms",
      data: {
        error: err,
      },
    });
  }

  validateEmail(email: string): boolean {
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private scrollToTop(): void {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }
}
